
/* global H5PStandalone */
import React from 'react';

const Sales = () => {
  return (
    <iframe
      src="/sales/index.html"
      title="H5P GameMap"
      width="100%"
      height="750px"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  );
};

export default Sales;